module.exports = __webpack_public_path__ + "static/image3-027a767347ac5fd0684bca8eccd49fea.png";